import { cn } from "../../../utils";
import { Icon } from "../../Icon";

export interface NavigationIconProps {
  direction: "previous" | "next";
  disabled?: boolean;
  onClick: () => void;
}

export const NavigationIcon: React.FC<NavigationIconProps> = ({
  direction,
  disabled,
  onClick,
}) => {
  return (
    <Icon
      size="sm"
      name="caret-up"
      disabled={disabled}
      className={cn(
        "ui:text-textTertiary ui:transition-colors ui:duration-500",
        {
          "ui:hover:text-textPrimary": !disabled,
          "ui:-rotate-90": direction === "previous",
          "ui:rotate-90": direction === "next",
        },
      )}
      onClick={onClick}
    />
  );
};
